/**
 * Created by vetal on 15.11.16.
 */
define('plugin/social-gallery/SocialGalleryPlugin',['require','lib/plugin/PluginAbstract','plugin/social-gallery/controller/SocialGalleryController','plugin/social-gallery/collection/SocialGalleryCollection','plugin/social-gallery/view/SocialGalleryModuleIndexView','lib/AppRouter'],function (require) {

    var PluginAbstract = require('lib/plugin/PluginAbstract');
    var SocialGalleryController = require('plugin/social-gallery/controller/SocialGalleryController');
    var SocialGalleryCollection = require('plugin/social-gallery/collection/SocialGalleryCollection');
    var SocialGalleryModuleIndexView = require('plugin/social-gallery/view/SocialGalleryModuleIndexView');
    var AppRouter = require('lib/AppRouter');

    return PluginAbstract.extend({

        _collection : null,
        _galleryModuleRegions: {
            gallery: '#sb_social_gallery'
        },
        _moduleView: null,

        initialize: function () {
            // code created by Vitaly. Fixed by dimka, to not load reviews when it not needed
            this._collection = new SocialGalleryCollection();

            var socialGalleryRouter = new AppRouter({
                appRoutes: {
                    'social-gallery': 'index',
                },
                menuItem: 'social_gallery',
                controller: new SocialGalleryController({
                    app: this.getOption('app'),
                    socialGalleryCollection : this._collection
                })
            });
        },

        initModules: function (view) {
            _.each(this._galleryModuleRegions, function (selector, galleryModuleRegion) {
                view.addRegion(galleryModuleRegion, selector);
            });

            //console.log(view.gallery.$el.length);
            if (view.gallery.$el.length) {
                if (!this._moduleView || this._moduleView.isDestroyed) {
                    this._moduleView = new SocialGalleryModuleIndexView({
                        collection : this._collection
                    });

                    this._collection.load();
                }
                view.gallery.show(this._moduleView);
            }
        }
    });

});
